import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useBooking } from "@/context/BookingContext";
import { useContent } from "@/context/ContentContext";

export const Adventures = () => {
  const { openTour } = useBooking();
  const { content } = useContent();
  const ADVENTURES = content.adventures;

  return (
    <section id="adventures" data-testid="adventures" className="bg-[#f4f1ea] px-6 py-28 lg:px-10 lg:py-40">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
            <div>
              <div className="overline mb-6">Our Experiences</div>
              <h2 className="max-w-2xl font-serif text-4xl font-medium leading-tight tracking-tight text-[#23281f] lg:text-6xl">
                Journeys, not <span className="italic text-[#ba5a45]">itineraries.</span>
              </h2>
            </div>
            <p className="max-w-sm text-[#5c6157]">
              Six ways to meet the Garhwal Himalaya — each guided by people who call these mountains home.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 lg:grid-cols-12 lg:gap-6">
          {ADVENTURES.map((a, i) => (
            <motion.button
              key={a.id}
              data-testid={`adventure-${a.id}`}
              onClick={() => openTour(a.name)}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative min-h-[300px] overflow-hidden text-left lg:min-h-[340px] ${a.span}`}
            >
              <img src={a.image} alt={a.name} className="img-zoom absolute inset-0 h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d110f] via-[#0d110f]/30 to-transparent" />
              <div className="relative flex h-full flex-col justify-between p-7 lg:p-8">
                <div className="flex items-center justify-between">
                  <span className="overline text-[#e2c9a0]">{a.category}</span>
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#f2efeb]/30 text-[#f2efeb] transition-all duration-500 group-hover:bg-[#ba5a45] group-hover:border-[#ba5a45]">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
                <div>
                  <h3 className="font-serif text-2xl text-[#f2efeb] lg:text-3xl">{a.name}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-[#c4c9c5] opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    {a.blurb}
                  </p>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
